import SvgIcon from '@material-ui/core/SvgIcon'
import React from 'react'

export const Drug = props => (
  <SvgIcon {...props}>
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Drug" fill="currentcolor" fillRule="nonzero">
        <g id="baseline-spellcheck-24px">
          <path
            d="M14.4,9.5v0.8c-0.6,0.2-1.1,0.5-1.6,0.8v0c0,0,0,0,0,0v-0.7h-2.5c-0.4,0-0.8-0.4-0.8-0.8s0.4-0.8,0.8-0.8h3.2
            c0,0,0,0,0,0C14.1,8.7,14.4,9,14.4,9.5z M11,12.7h-0.6v-0.6c0-0.4-0.3-0.8-0.8-0.8c-0.4,0-0.8,0.3-0.8,0.8v0.6H8.2
            c-0.4,0-0.8,0.3-0.8,0.8c0,0.4,0.3,0.8,0.8,0.8h0.6v0.6c0,0.4,0.3,0.8,0.8,0.8c0,0,0,0,0.1,0C9.9,14.6,10.4,13.6,11,12.7
            C11,12.7,11,12.7,11,12.7z M11.5,22.4H7.2c-0.8,0-1.5-0.4-1.9-0.9H2.9c-1.3,0-2.3-1-2.3-2.3V8.9c0-0.7,0.4-1.4,1-1.9V3.1
            c0-1.1,0.9-2,2-2h2.6c0.4-0.6,1-0.9,1.8-0.9h8.2c0.7,0,1.4,0.4,1.8,0.9h2.6c1.1,0,2,0.9,2,2V7c0.6,0.4,1,1.1,1,1.9v4.6
            c-0.4-0.7-0.9-1.3-1.5-1.9l0-2.4c0,0,0,0,0,0V8.9c0-0.4-0.3-0.8-0.8-0.8h-1.9c0,0.2,0.1,0.4,0.1,0.5v1.5c-0.5-0.2-1-0.3-1.6-0.3
            l0-0.8c0,0,0,0,0,0V8.7c0-0.5-0.4-0.9-0.9-0.9H7.2c-0.5,0-0.9,0.4-0.9,0.9h1.5c0.4,0,0.8,0.4,0.8,0.8c0,0.4-0.4,0.8-0.8,0.8H6.3
            l0,6.8h3.2c0,0.1,0,0.2,0,0.3c0,0.5,0,0.9,0.1,1.3H6.3l0,1.3c0,0.5,0.4,0.9,0.9,0.9h3.2C10.6,21.4,11,22,11.5,22.4z M18.3,6.7
            C18.3,6.7,18.3,6.7,18.3,6.7c0.1,0,0.2,0,0.2,0h2.4V3.1c0-0.2-0.2-0.5-0.5-0.5h-2.2V6.7z M7.3,6.2h9.3V2.4c0-0.3-0.2-0.5-0.5-0.5
            H7.9c-0.3,0-0.5,0.2-0.5,0.5V6.2z M4.7,20V8.7c0-0.2,0-0.4,0.1-0.5H2.9c-0.4,0-0.8,0.4-0.8,0.8v0.3c0,0,0,0,0,0l0,9.9
            c0,0.4,0.3,0.8,0.8,0.8L4.7,20C4.7,20,4.7,20,4.7,20z M5.7,2.7H3.5c-0.2,0-0.5,0.2-0.5,0.5v3.5h2.4c0.1,0,0.1,0,0.2,0.1
            c0,0,0,0,0,0V2.7z M23.4,17.3c0,3.6-2.9,6.5-6.5,6.5s-6.5-2.9-6.5-6.5s2.9-6.5,6.5-6.5S23.4,13.7,23.4,17.3z M20.4,19.6h-6.7v1h6.7
            V19.6z M20.4,16.8h-6.7v1h6.7V16.8z M20.4,13.9h-6.7v1h6.7V13.9z"
            id="Shape"
          />
        </g>
      </g>
    </g>
  </SvgIcon>
)

export default Drug



// WEBPACK FOOTER //
// ./src/icons/InteractionType.js